import { Component,  HostBinding,  Input } from '@angular/core';
import { IconComponent } from 'src/app/components/icon/icon.component';

@Component({
    selector: 'app-icon',
    template: `
<icon [icon]="icon"></icon>
<div class="title ellipsis">{{ title }}</div>
`,
    styles: [`
  :host { display: flex; padding: 5px; border: 1px solid var(--innercontentbgoutline); background: var(--pagebackground); flex-direction: column; align-items: center; border-radius: 15px; cursor: pointer; width: 80px; height: 80px; justify-content: center; }
  :host.active { border: 1px solid var(--primary); }
  icon { color: var(--normal-text); }
  :host.active icon { color: var(--primary); }
  :host.active .title { color: var(--primary); }
  .title { font-size: 11px; color: var(--normal-text); max-width: 100%; }
`],
    standalone: true,
    imports: [IconComponent],
})
export class AppIconComponent {
  @Input() icon: string
  @Input() title: string
  @Input() active: boolean
  @HostBinding('class.active') get isActive(){ return !!this.active }
}

